<template>
<section>
    <p id="title" ref="title" class="photo-text">Take Photo</p>
    <p id="message" ref="message" class="text-center" :class="detections.lifeProofDetected ? 'd-none' : 'd-block'">{{detections.message ? detections.message : 'Smile for the camera'}}</p>
    <div id="container" class="text-center" :class="detections.lifeProofDetected ? 'd-none' : 'd-block'">
        <div id="video-container">
            <div v-if="!videoShow">
                <div class="photo__wrapper" @click="loadModels">
                    <feather class="feather-icon" type="camera"></feather>
                </div>
            </div>
            <p v-if="loading" class="text-danger">Please wait...</p>
            <div id="inner-container" ref="inner-container" v-if="videoShow">
                <video id="video" @play="playVideo" ref="camera" width="320" height="420" autoplay muted></video>
            </div>
            <div id="emotions" ref="emotions" :class="detections.lifeProofDetected ? 'd-none' : 'd-block'">
                <span :class="detections.smileDetected ? 'd-block' : 'd-none'" id="smile" ref="smile">
                    <strong>Smile</strong>
                    <img width="20" alt="Smile detected" src="@/assets/TAJimages/ticked.gif" />
                </span>
                <span :class="detections.stillDetected ? 'd-block' : 'd-none'" id="still" ref="still">
                    <strong>Still</strong>
                    <img width="20" alt="Still detected" src="@/assets/TAJimages/ticked.gif" />
                </span>
            </div>
            <canvas id="canvas" ref="canvas"></canvas>
        </div>
    </div>
    <div>
        <img width="100%" height="200" id="result" ref="result" src="" :class="detections.lifeProofDetected ? 'd-block' : 'd-none'" />
        <p id="button" @click="takeAnother" :class="detections.lifeProofDetected ? 'd-block' : 'd-none'">Take Another Picture</p>
    </div>
</section>
  
</template>

<script>
  import * as faceapi from 'face-api.js';
  export default {
    data:() => ({
      detections: {
        smileDetected: false,
        stillDetected: false,
        lifeProofDetected: false,
        faceDetected: true,
        message: 'Smile for the camera',
      },
      videoShow: false,
      imageD: '',
      expCount: 0,
      expression: ['happy', 'neutral'],
      loading: false,
    }),
    mounted() {
    },
    methods: {
      loadModels() {
        this.videoShow = true; 
        this.loading = true;
        return Promise.all([
          faceapi.nets.faceExpressionNet.loadFromUri('models'),
          faceapi.nets.tinyFaceDetector.loadFromUri('models'),
          faceapi.nets.faceRecognitionNet.loadFromUri('models'),
        ]).then(() => {
          this.loading = false;
          this.startVideo();
        });
      },
      startVideo() {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          this.loading = true;
          navigator.mediaDevices.getUserMedia({ video: true, audio: false }).then(stream => {
            this.loading = false;
            window.localStream = stream;
            this.$refs.camera.srcObject = stream;
            // video.play();
          }).catch((err) => this.setDetections({ ...this.detections, message: err }));
        }
      },
      // stop video
      stopVideo() {
        if (window.localStream) {
          window.localStream.getTracks().forEach(track => track.stop());
        }
      },
      // isFaceDetectionModelLoaded
      async isFaceDetectionModelLoaded() {
        return faceapi.nets.tinyFaceDetector.params;
      },
      async getFullFaceDescription2(blob, inputSize = 416) {
        let scoreThreshold = 0.5;
        const OPTION = new faceapi.TinyFaceDetectorOptions(inputSize, scoreThreshold);

        let img = await faceapi.fetchImage(blob);

        let fullDesc = await faceapi
          .detectAllFaces(img, OPTION)
          .withFaceExpressions();
        return fullDesc;
      },
      // determine proof of life
      determineProofOfLife({
        neutral,
        happy,
        sad,
        angry,
        fearful,
        disgusted,
        surprised,
      }) {
        //set neutral to be the face expression nad then replace it if other expressions come up with higher scores
        let faceExpression = ['neutral', neutral];
        if (happy > faceExpression[1]) faceExpression = ['happy', happy];
        else if (sad > faceExpression[1]) faceExpression = ['neutral', sad];
        else if (angry > faceExpression[1]) faceExpression = ['neutral', angry];
        else if (fearful > faceExpression[1]) faceExpression = ['fearful', fearful];
        else if (disgusted > faceExpression[1])
          faceExpression = ['disgusted', disgusted];
        else if (surprised > faceExpression[1])
          faceExpression = ['surprised', surprised];

        return faceExpression[1] >= 0.5 ? faceExpression[0] : null;
      },
      // delay capture
      delayCapture() {
        setTimeout(() => this.webcamCapture());
      },
      webcamCapture() {
        if (this.expCount <= 1) {
          let picCanvas = this.$refs.canvas;
          let video = this.$refs.camera;
          var context = picCanvas.getContext('2d');
          picCanvas.width = video.width;
          picCanvas.height = video.height;
          context.drawImage(video, 0, 0, video.width, video.height);
          this.imageD = picCanvas.toDataURL('image/png');
          this.handleImage();
        }
      },
      async handleImage() {
        if (!this.imageD || !this.isFaceDetectionModelLoaded()) this.webcamCapture();

        await this.getFullFaceDescription2(this.imageD).then(async (fullDesc) => {
          if (fullDesc.length > 1) {
            this.expCount = 0;
            this.setDetections({
              ...this.detections,
              smileDetected: false,
              stillDetected: false,
              message: 'Just you please',
            });
            this.webcamCapture();
          } else if (fullDesc.length === 0) {
            if (this.expCount === 0)
              this.setDetections({
                ...this.detections,
                message: 'Move closer and smile',
              });
            if (this.expCount === 1)
              this.setDetections({
                ...this.detections,
                message: 'Move closer and stay still',
              });
            this.delayCapture();
          } else if (fullDesc.length === 1) {
            const userExpression = await this.determineProofOfLife(
              fullDesc[0]['expressions']
            );
            if (this.expression[this.expCount] === userExpression) {
              if (this.expCount === 0) {
                this.setDetections({
                  ...this.detections,
                  smileDetected: true,
                  message: 'Now give a straight face',
                });
              }
              if (this.expCount === 1) {
                this.setDetections({
                  ...this.detections,
                  smileDetected: true,
                  stillDetected: true,
                  message: 'All Done',
                });

                setTimeout(() => {
                  this.setDetections({ ...this.detections, lifeProofDetected: true });
                }, 800);
              }
              this.expCount += 1;
              this.delayCapture();
            } else {
              if (this.expCount === 0)
                this.setDetections({ ...this.detections, message: 'Now give a huge smile' });
              if (this.expCount === 1)
                this.setDetections({
                  ...this.detections,
                  message: 'Now give a straight face',
                });

              this.webcamCapture();
            }
          }
        });
      },
      // set detections
      setDetections(obj) {
        let detections = { ...obj };
        this.detections = detections;
        this.$refs.message = detections.message;
        this.$refs.title.innerHTML = detections.lifeProofDetected ? 'Face captured' : 'Take picture';
        this.$refs.result.setAttribute('src', this.imageD);
        // dispatch image
        this.$store.commit('SET_IMAGE', this.imageD);

        detections.lifeProofDetected && this.stopVideo();
      },
      playVideo() {
        this.delayCapture();
      },
      takeAnother() {
        this.setDetections({
          smileDetected: false,
          stillDetected: false,
          lifeProofDetected: false,
          faceDetected: true,
          message: 'Smile for the camera',
        });
        this.expCount = 0;
        this.loadModels();
        // this.startVideo();
      }
    }
  };
</script>

<style scoped>
canvas {
	position: absolute;
}

#canvas {
	display: none;
}

#title {
	/* margin-bottom: 0; */
	text-align: center;
}

#message {
	/* margin-bottom: -80px; */
  font-size: 18px;
  font-weight: 500;
	text-align: center !important;
}

#container {
	display: flex;
	flex-flow: column;
	align-items: center;
	justify-content: center;
    margin-bottom: 60px;
}

#video-container {
	/* display: flex;
	flex-flow: row wrap;
	align-items: center;
	justify-content: center; */
}

#inner-container {
	display: flex;
	flex-flow: column nowrap;
	justify-content: center;
	align-items: center;
    margin-top: -75px;
}

#inner-container video {
	/* margin-right: 5px;
	margin-bottom: 5px; */
}

#emotions,
#emotions-mobile {
	display: flex;
	flex-flow: column wrap;
    margin-top: -70px;
}

#emotions span,
#emotions-mobile span {
	/* margin: 5px; */
}

#button {
	/* width: 100%; */
	/* background-color: #e41f13; */
	color: #e41f13;
	/* height: 40px; */
	margin-top: 8px;
	/* border-radius: 5px; */
	/* border: 0; */
  text-align: center;
  cursor: pointer;
}
.photo__wrapper {
    background-color: #DF351708;
    border: 3px solid #DF351712;
    border-radius: 10px;
    padding: 20px;
    height: 95px;
    width: 100%;
}
.photo-text {
    font-size: 18px;
    letter-spacing: 0px;
    margin-bottom: 10px;
    font-weight: 500;
}
.photo__wrapper >>> .feather-icon {
    color: #E41613;
    margin: 5px 0px;
}
@media screen and (max-width: 560px) {
	#message {
		margin-bottom: 0;
	}
}
</style>